import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearRoom, getAllRooms, getRoom, joinToRom, manageSocialRoom, requestToRom, seeMyRooms, seeRoomsIBelong } from '../../../actions/userActions';
import { seeListChatCategories } from '../../../admin/actions/categoriesActions';
import JoinView from '../../../containers/ChatRooms/Room/Join/Join';
import localStorage from '../../../utils/hooks/useLocalStorage';
import { useTokenCallback } from '../../../utils/hooks/useTokenCallback';

const Join = ({ match, history }) => {
    const dispatch = useDispatch()
    const { roomInfo, roomsIBelong, userInfo } = useSelector(state => state.userInfo)

    useTokenCallback(() => {
        dispatch(getAllRooms())
        dispatch(seeListChatCategories())
        dispatch(seeRoomsIBelong())
        dispatch(seeMyRooms())


    }, [])
    useTokenCallback(() => {
        dispatch(getRoom(match.params.idRoom))
    }, [match.params.idRoom])

    useEffect(() => {
        if (roomInfo.lenght) {
            history.push(`/Rooms`)
        }


    }, [roomInfo]);

    useEffect(() => {
        return () => {
            console.log();
            dispatch(clearRoom());
        };
    }, []);
    const request = () => {
        dispatch(manageSocialRoom({
            chatRoomID: match.params.idRoom,
            type: 0
        }))
    }

    const join = () => {
        let id = localStorage().getItem('idProfile')
       
        dispatch(joinToRom(roomInfo._id,id, history))
    }
    let isPrivate = true
    let iCanJoin = false
    useEffect(() => {
        if (roomInfo._id) {
            let id = localStorage().getItem('idProfile')
           
            isPrivate = roomInfo.privacity === 1;
            iCanJoin = roomInfo.adminID ===id
        }


        return () => {

        }
    }, [roomInfo])

    return <JoinView join={join} room={roomInfo} request={request} roomsIBelong={roomsIBelong} />;
};

export default Join;
